import { orderReportName } from '@/shared/i18n/orderReportName';

export const getOrderReportDefaultName = <
  Key extends keyof typeof orderReportName,
>(
  key: Key,
): string => {
  const { defaultMessage, id } = orderReportName[key];

  return typeof defaultMessage === 'string' ? defaultMessage : id ?? '';
};
